import * as seGuides from './se/index';
import * as ukGuides from './uk/index';
import * as testGuides from './test/index';

export const se = seGuides;
export const uk = ukGuides;
export const test = testGuides;
